import React from "react";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select from "react-select";
import calender_icon from ".././assets/images/icon/calender.svg";
import action1 from ".././assets/images/icon/action_1.svg";
import action2 from ".././assets/images/brands/on-hold.svg";
import action3 from ".././assets/images/brands/Rejected.svg";
import serach_icon from ".././assets/images/icon/search-icon.svg";
import { CSVLink } from "react-csv";
import {
  downloadCSVReport,
  getAdminFeedbackData,
  getCandidateNotes,
  removeCandidateNotes,
} from "helpers/backend_helper";
import { toast } from "react-toastify";

import delete_icon from ".././assets/images/icon/delete.svg";

import Reschedule from ".././assets/images/icon/Reschedule.svg";
import copyicon from ".././assets/images/icon/copyicon.svg";

import write_feedback from ".././assets/images/icon/write-feedback.svg";
import Interview_elavtor from ".././assets/images/icon/Interview_elavtor.svg";

import gmeet from ".././assets/images/icon/g-meet.svg";
import zoom from ".././assets/images/icon/zoom.png";
import teams from ".././assets/images/icon/microsoft-teams.png";
import locationma from ".././assets/images/icon/location-card.svg";
import locations from ".././assets/images/icon/location-s.svg";
import mode from ".././assets/images/icon/Mode.svg";

import blue_users from ".././assets/images/icon/blue-users.svg";
import start_p7 from ".././assets/images/icon/start-p7.svg";
import arrow_ico from ".././assets/images/icon/arrow-ico.svg";
import addnotoes from ".././assets/images/icon/addnotoes.svg";

import date from ".././assets/images/icon/date.svg";
import time from ".././assets/images/icon/time.svg";

import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
  getDeviceInfo,
  formatDate,
  checkMeetingPlatform,
} from "helpers/utils";
import { updateselected } from "services/scheduledService";
import authHeader from "helpers/jwt-token-access/auth-token-header";
import { Spinner } from "reactstrap";
import {
  getInterviewStatus,
  getRangeDateTimeString,
  getFilterStatus,
} from "helpers/common";
import { getUserInfo, getUserToken } from "helpers/authHelper";
import moment from "moment";
import { decryptDataFromArray } from "helpers/EncDec";
import { MultiSelect } from "react-multi-select-component";
import RatingStars from ".././pages/Screening_Test/RatingStars";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import {
  faCircleHalfStroke,
  faEdit,
  faPause,
  faRemove,
} from "@fortawesome/free-solid-svg-icons";
import { element, string } from "prop-types";
import TimeslotBookingAdmin from "../pages/Screening_Test/TimeslotBookingAdmin";
import ButtonLoader from "components/Common/ButtonLoader";
import { Trans, useTranslation } from "react-i18next";

const RoundList = ({
  roundListData,
  handleTabClick,
  feedbackInfo,
  allNotes,
  handleRemoveNote,
  toggleReadMore,
  toggleAccordion,
  handleInterviewModal,
  handleScreenTest,
  setRoundStatus,
  handleUpdateRoundStatus,
  getAssesmentLink,
  handleCopyLink,
  setActiveTab,
  activeTab,
  activeIndex,
  setActiveIndex,
  t,
  roundStatus,
  readMoreStates,
  selectedCandidate,
  open_slider,
  handleShow,
}) => {
  const interviewStatus = [
    { value: "0", label: "Pending" },
    { value: "2", label: "Skip" },
    { value: "3", label: "On Hold" },
    { value: "4", label: "Completed" },
    { value: "5", label: "Shortlisted" },
    { value: "6", label: "Not Attempted" },
  ];

  const handleCopyLinkChild = async linkToCopy => {
    try {
      await navigator.clipboard.writeText(linkToCopy);
      toast.success("The link has been copied to your clipboard!");
    } catch (error) {
      toast.error("Unable to copy the link");
      console.error("Failed to copy text: ", error);
    }
  };

  const userInfo = getUserInfo();
  const userloggedinId = userInfo?.id;

  return (
    <>
      {roundListData?.length > 0 &&
        roundListData?.map((el, index) => {
          /*
           * Get interviewer ID from all supported API response structures.
           */
          const interviewerId =
            el?.interviewer?.interviewer_id ||
            el?.interviewer_data?.interviewer_id ||
            el?.interviewer?.user?.id ||
            el?.interviewer_data?.user?.id ||
            el?.interviewDetails?.user?.id ||
            el?.interviewDetails?.interviewer_id ||
            null;

          /*
           * Current logged-in user is the assigned interviewer.
           */
          const isAssignedInterviewer =
            interviewerId &&
            Number(interviewerId) === Number(userloggedinId);

          /*
           * Schedule is an ACTION under Scheduled Application.
           *
           * A user can schedule/reschedule when:
           * 1. The user is the assigned interviewer, OR
           * 2. The user's role has the "schedule" action.
           *
           * Role hierarchy is not considered here.
           */
          const hasSchedulePermission = checkPermissionStatus(
            "screening-list",
            "schedule"
          );

          const canScheduleInterview =
            el?.roundType !== "Test" &&
            (isAssignedInterviewer || hasSchedulePermission);

          /*
           * Display interviewer name.
           */
          const interviewerName =
            el?.interviewer?.user?.name ||
            el?.interviewer?.name ||
            el?.interviewer_data?.name ||
            "";

          if (
            ["Skipped", "Completed", "Shortlisted"]?.includes(
              el?.roundStatus
            ) &&
            feedbackInfo?.allFeedbacks?.filter(
              item => item?.interview_type_id === el?.roundId
            ).length > 0
          ) {
            return (
              <div className="accrodion-cards-item">
                <div
                  className="accrodion-cards-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <div className="arrow-ico">
                    <span>
                      <img src={arrow_ico} />
                    </span>

                    <h4 className={`${el?.roundStatus}`}>
                      {el?.roundName} <span>{el?.roundStatus}</span>
                    </h4>
                  </div>
                </div>

                {activeIndex === index && (
                  <div className="accrodion-cards-body">
                    <div className="tecnical-card-progress">
                      <div className="d-flex gap-4 pending-cards">
                        <div className="acordion-ca">
                          <div className="accordion-heading">
                            <strong>Round Name</strong>
                            <h5>{el?.roundName}</h5>
                          </div>
                        </div>

                        <div className="acordion-ca ">
                          <div className="accordion-heading">
                            <strong>Round Type:</strong>
                            <h5>{el?.roundType}</h5>
                          </div>
                        </div>

                        <div className="acordion-ca">
                          <div className="accordion-heading">
                            <strong>Round Status:</strong>
                            <h5>{el?.roundStatus}</h5>
                          </div>
                        </div>

                        <div className="acordion-ca ">
                          <div className="accordion-heading">
                            <strong>Candidate Status</strong>
                            <h5>
                              {`${el?.interviewDetails?.candidate_status}` ===
                              "1"
                                ? "Done"
                                : "Pending"}
                            </h5>
                          </div>
                        </div>

                        <div className="acordion-ca ">
                          <div className="accordion-heading">
                            <strong>Date</strong>
                            <h5>
                              {formatDate(
                                el?.testDetails?.createdAt ||
                                  el?.interviewer_data?.createdAt
                              )?.replace(/,.*/, "")}
                            </h5>
                          </div>
                        </div>

                        <div className="acordion-ca ">
                          <div className="accordion-heading">
                            <strong>Time</strong>
                            <h5>
                              {" "}
                              {formatDate(
                                el?.testDetails?.createdAt ||
                                  el?.interviewer_data?.createdAt
                              )?.replace(/^.*,/, "")}
                            </h5>
                          </div>
                        </div>
                      </div>

                      <div className="accordion-card-pe">
                        <div className="tab-buttons">
                          <button
                            className={activeTab === "tab1" ? "active" : ""}
                            onClick={() => handleTabClick("tab1")}
                          >
                            Interview Feedback
                          </button>

                          {/* <button
                            className={activeTab === "tab2" ? "active" : ""}
                            onClick={() => handleTabClick("tab2")}
                          >
                            Notes
                          </button> */}
                        </div>

                        <div className="tab-content">
                          {activeTab === "tab1" &&
                            feedbackInfo?.allFeedbacks
                              ?.filter(
                                item =>
                                  item?.interview_type_id === el?.roundId
                              )
                              ?.map((element, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="tabs1-ctabcoment"
                                  >
                                    <div className="tabs-content-slider">
                                      <div className="tabs-slider-img">
                                        <div className="tabs-content-slider-item">
                                          <img src={blue_users} />
                                        </div>

                                        <div className="tabs-header">
                                          <h4>{element?.user?.username}</h4>
                                          <h5>{element?.user?.role?.name}</h5>
                                        </div>
                                      </div>

                                      <div className="tabs-cotent">
                                        <span>
                                          <div className="total-average-rating">
                                            {[...Array(5)].map((_, i) => {
                                              if (
                                                i <
                                                Math.floor(
                                                  element?.feedbackScore
                                                )
                                              ) {
                                                return (
                                                  <FontAwesomeIcon
                                                    key={i}
                                                    icon={faStar}
                                                    style={{
                                                      color: "#FEAE44",
                                                    }}
                                                  />
                                                );
                                              } else if (
                                                i ===
                                                  Math.floor(
                                                    element?.feedbackScore
                                                  ) &&
                                                element?.feedbackScore % 1 >=
                                                  0.5
                                              ) {
                                                return (
                                                  <FontAwesomeIcon
                                                    key={i}
                                                    icon={faStarHalfAlt}
                                                    style={{
                                                      color: "#FEAE44",
                                                    }}
                                                  />
                                                );
                                              } else {
                                                return (
                                                  <FontAwesomeIcon
                                                    key={i}
                                                    icon={faStarHalfAlt}
                                                    style={{
                                                      color: "#E0E0E0",
                                                    }}
                                                  />
                                                );
                                              }
                                            })}
                                          </div>

                                          {Math.round(
                                            element?.feedbackScore * 10
                                          ) / 10}
                                        </span>

                                        <p>{element?.comments}</p>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          } else {
            return (
              <div
                key={index}
                className={`accrodion-cards-item ${
                  activeIndex === index ? "active" : ""
                }`}
                eventKey={`${index}`}
              >
                <div
                  className="accrodion-cards-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <div className="arrow-ico">
                    <span>
                      <img src={arrow_ico} alt="" />
                    </span>

                    <h4 className={`${el?.roundStatus}`}>
                      {el?.roundName}
                      {" : "}
                      {interviewerName || ""}
                      <span>{el?.roundStatus}</span>
                    </h4>
                  </div>
                </div>

                {activeIndex === index && (
                  <div className="accrodion-cards-body">
                    <div className="pending-card">
                      <div className="d-flex gap-4 pending-cards">
                        <div className="acordion-ca">
                          <div className="accordion-heading">
                            <strong>{t(`ATS View.Round Name`)}:</strong>{" "}
                            <h5>{el?.roundName}</h5>
                          </div>
                        </div>

                        <div className="acordion-ca ">
                          <div className="accordion-heading">
                            <strong>{t(`ATS View.Round Type`)}:</strong>{" "}
                            <h5>{el?.roundType}</h5>
                          </div>
                        </div>

                        <div className="acordion-ca">
                          <div className="accordion-heading">
                            <strong>{t(`ATS View.Round Status`)}:</strong>{" "}
                            <h5>{el?.roundStatus}</h5>
                          </div>
                        </div>

                        <div className="acordion-ca">
                          <div className="accordion-heading">
                            <strong>Last Updated:</strong>{" "}
                            <h5>
                              {el?.interviewer_data &&
                              Object.keys(el?.interviewer_data).length > 0 ? (
                                <>{el?.interviewer_data?.createdAt}</>
                              ) : (
                                "N/A"
                              )}
                            </h5>
                          </div>
                        </div>

                        <div className="acordion-ca">
                          <div className="accordion-heading">
                            <strong>{t(`ATS View.Candidate Status`)}</strong>{" "}
                            <h5 className="confirmed-icon">
                              {`${el?.interviewDetails?.candidate_status}` ===
                              "1"
                                ? "Done"
                                : "Pending"}
                            </h5>
                          </div>
                        </div>
                      </div>
                                            {(!["Skipped", "Completed", "Shortlisted"]?.includes(
                        el?.roundStatus
                      ) ||
                        el?.roundType !== "Test") && (
                        <div className="d-flex justify-content-between align-items-center gap-3 select-bar assement-select intevriero mt-3 w-100">
                          {el?.interviewDetails && (
                            <div className="interview-details-p7">
                              <div className="interview-mode-card">
                                <span>
                                  <img
                                    src={mode}
                                    alt=""
                                    className="location2"
                                  />
                                </span>

                                <div className="mode-virtual">
                                  <h5>Mode</h5>
                                  <h3 className="virtual-span">
                                    {el?.interviewDetails?.meeting_type === 1
                                      ? "Virtual"
                                      : "Offline"}
                                  </h3>
                                </div>
                              </div>

                              <div className="interview-mode-card">
                                <span>
                                  <img
                                    src={date}
                                    alt=""
                                    className="opacityimg"
                                  />
                                </span>

                                <div className="mode-virtual">
                                  <h5>Date</h5>
                                  <h3>
                                    {el?.interviewDetails
                                      ? formatDate(
                                          el?.interviewDetails
                                            ?.int_schedule_date
                                        )?.replace(/,.*/, "")
                                      : ""}
                                  </h3>
                                </div>
                              </div>

                              <div className="interview-mode-card">
                                <span>
                                  <img
                                    src={time}
                                    alt=""
                                    className="opacityimg"
                                  />
                                </span>

                                <div className="mode-virtual">
                                  <h5>Time Slot</h5>
                                  <h3>
                                    {
                                      el?.interviewDetails
                                        ?.int_schedule_time
                                    }
                                  </h3>
                                </div>
                              </div>

                              <div className="interview-mode-card">
                                {el?.interviewDetails?.meeting_type === 0 && (
                                  <span>
                                    <img
                                      src={locations}
                                      alt=""
                                      className="location1"
                                    />
                                  </span>
                                )}

                                {el?.interviewDetails?.meeting_type === 0 ? (
                                  <div className="mode-virtual">
                                    <h5>Address</h5>
                                    <h3 className="gmeet-icon">
                                      {el?.interviewDetails?.f2f_address}
                                    </h3>
                                  </div>
                                ) : (
                                  <div className="mode-virtual">
                                    <h5>Meeting Link</h5>
                                    <h3 className="gmeet-icon">
                                      <span>
                                        <img
                                          src={
                                            checkMeetingPlatform(
                                              el?.interviewDetails?.team_link
                                            ) === "Zoom"
                                              ? zoom
                                              : checkMeetingPlatform(
                                                  el?.interviewDetails
                                                    ?.team_link
                                                ) === "Google Meet"
                                              ? gmeet
                                              : checkMeetingPlatform(
                                                  el?.interviewDetails
                                                    ?.team_link
                                                ) === "Microsoft Teams"
                                              ? teams
                                              : ""
                                          }
                                          alt=""
                                        />
                                      </span>

                                      <a
                                        href={
                                          el?.interviewDetails?.team_link
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Meeting Link
                                      </a>
                                    </h3>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {/* Assigned interviewer message */}
                          {![
                            "Skipped",
                            "Completed",
                            "Shortlisted",
                          ]?.includes(el?.roundStatus) &&
                            isAssignedInterviewer && (
                              <p>
                                Please take the necessary steps to update and
                                complete the status for this {el?.roundType}{" "}
                                round
                              </p>
                            )}

                          <div className="assement-select-drp">
                            {/* Update Round Status Dropdown */}
                            {![
                              "Skipped",
                              "Completed",
                              "Shortlisted",
                            ]?.includes(el?.roundStatus) &&
                              isAssignedInterviewer && (
                                <div className="assement-select-ro">
                                  <div className="select-starus">
                                    <Select
                                      className="mb-2"
                                      placeholder={t(
                                        `ATS View.Update Round Status`
                                      )}
                                      id="interview_status"
                                      name="interview_status"
                                      options={interviewStatus}
                                      value={
                                        interviewStatus?.find(
                                          el => el?.value === roundStatus
                                        ) || ""
                                      }
                                      onChange={e =>
                                        setRoundStatus(e?.value)
                                      }
                                      isDisabled={
                                        !el || !el.isCurrentRound
                                      }
                                    />
                                  </div>

                                  {/* Update Round Status Button */}
                                  <Button
                                    onClick={() =>
                                      handleUpdateRoundStatus(
                                        el?.interviewDetails?.id ||
                                          el?.testDetails?.id ||
                                          "",
                                        el?.roundId,
                                        el?.roundStatus,
                                        el?.roundName,
                                        el?.roundType,
                                        selectedCandidate?.user_id,
                                        selectedCandidate?.vacancy_id
                                      )
                                    }
                                    variant="outline-primary"
                                    size="sm"
                                    disabled={
                                      !el || !el.isCurrentRound
                                    }
                                  >
                                    {t(`ATS View.Update Status`)}
                                  </Button>
                                </div>
                              )}

                            {/* Reschedule / Schedule Button */}
                            <div className="reschedule-btn-link">
                              {![
                                "Skipped",
                                "Completed",
                                "Shortlisted",
                              ]?.includes(el?.roundStatus) &&
                                el?.isCurrentRound &&
                                canScheduleInterview &&
                                (el?.interviewDetails ? (
                                  /* Reschedule Interview Button */
                                  <a
                                    className={`Reschedule_interview ${
                                      !el ||
                                      (!el.isCurrentRound &&
                                        "disabled-section-card")
                                    }`}
                                    data-id={
                                      el?.interviewDetails?.id
                                    }
                                    onClick={() => {
                                      handleInterviewModal(
                                        el?.roundId,
                                        el?.roundType,
                                        el?.roundName,
                                        el?.roundStatus,
                                        parseInt(
                                          el?.interviewDetails
                                            ?.meeting_type || 0
                                        ),
                                        el?.interviewDetails?.id,
                                        "reschedule",
                                        el?.interviewDetails,
                                        interviewerId
                                      );
                                    }}
                                  >
                                    <img
                                      src={Reschedule}
                                      alt="Reschedule"
                                    />
                                    {t(`ATS View.Reschedule`)}{" "}
                                  </a>
                                ) : (
                                  /* Schedule Interview Button */
                                  <a
                                    className={`Reschedule_interview ${
                                      !el ||
                                      (!el.isCurrentRound &&
                                        "disabled-section-card")
                                    }`}
                                    data-id={
                                      el?.interviewDetails?.id
                                    }
                                    onClick={() => {
                                      handleInterviewModal(
                                        el?.roundId,
                                        el?.roundType,
                                        el?.roundName,
                                        el?.roundStatus,
                                        parseInt(
                                          el?.interviewDetails
                                            ?.meeting_type || 0
                                        ),
                                        el?.interviewDetails?.id,
                                        "schedule",
                                        el?.interviewDetails,
                                        interviewerId
                                      );
                                    }}
                                  >
                                    <img
                                      src={Reschedule}
                                      alt="Schedule"
                                    />
                                    {t(`ATS View.Schedule`)}{" "}
                                  </a>
                                ))}
                                                              {/* Write Feedback Button */}
                              {el?.roundType != "Test" &&
                                isAssignedInterviewer && (
                                  <a
                                    className={`feedback_interview ${
                                      !el ||
                                      (!el.isCurrentRound &&
                                        "disabled-section-card")
                                    }`}
                                    data-id={
                                      el?.interviewDetails?.id
                                    }
                                    onClick={() =>
                                      open_slider(
                                        selectedCandidate?.appl_id,
                                        8,
                                        el?.roundId
                                      )
                                    }
                                  >
                                    <img
                                      src={write_feedback}
                                      alt="write_feedback"
                                    />
                                    {t(`ATS View.Feedback`)}
                                  </a>
                                )}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Interview Evaluator Button */}
                      {![
                        "Skipped",
                        "Completed",
                        "Shortlisted",
                      ]?.includes(el?.roundStatus) &&
                        isAssignedInterviewer &&
                        el?.roundType !== "Test" &&
                        el?.interviewer?.interviewer_id ===
                          userloggedinId &&
                        el?.interviewer?.interview_type_id ===
                          el?.roundId && (
                          <div className="feedback-interview-ele">
                            <a
                              className={`feedback_interview ${
                                !el ||
                                (!el.isCurrentRound &&
                                  "disabled-section-card")
                              }`}
                              onClick={() => {
                                getAssesmentLink(
                                  el?.roundId,
                                  selectedCandidate?.appl_id,
                                  selectedCandidate?.user_id,
                                  selectedCandidate?.vacancy_id
                                );
                              }}
                            >
                              <img
                                src={Interview_elavtor}
                                alt="write_feedback"
                              />
                              Interview Evaluator
                            </a>

                            {/* Copy Assessment Link Button */}
                            <div
                              className={`copy-ciocn ${
                                !el ||
                                (!el.isCurrentRound &&
                                  "disabled-section-card")
                              }`}
                            >
                              <img
                                src={copyicon}
                                alt="copyicon"
                                onClick={() =>
                                  handleCopyLinkChild(
                                    el?.testDetails?.exam_url
                                  )
                                }
                              />
                            </div>
                          </div>
                        )}

                      {/* Start Assessment */}
                      {el?.roundStatus === "Pending" &&
                        el?.isCurrentRound &&
                        !el?.interviewDetails &&
                        el?.roundType === "Test" && (
                          <div className="text-start mb-0 mt-3">
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                handleScreenTest(
                                  el?.roundId,
                                  selectedCandidate?.appl_id,
                                  selectedCandidate?.user_id,
                                  selectedCandidate?.vacancy_id,
                                  1
                                )
                              }
                            >
                              {t(`ATS View.Start Assessment`)}
                            </button>
                          </div>
                        )}
                    </div>
                  </div>
                )}
              </div>
            );
          }
        })}
    </>
  );
};

export default RoundList;